/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Field to sort by.
*/
export enum SnapshotSortField {
  SNAPSHOT_SORT_POINT_IN_TIME = 'pointInTime'
}
